import {Country} from "../../../region/types/Country";

export function isApplicationAbroad(originalApplicationCountry: Country | null | string | undefined) {
    return Boolean(originalApplicationCountry) && originalApplicationCountry != Country.POLAND;
}
import {Country} from "../../../region/types/Country";

export function isApplicationAbroad(originalApplicationCountry: Country | null | string | undefined) {
    return Boolean(originalApplicationCountry) && originalApplicationCountry != Country.POLAND;
}
